import distanceCoursesLocale from './en.json'

const en = {
  distanceCourses: distanceCoursesLocale,
}

export default en
